<style src="./ListHeader.scss"lang="scss"></style>
<template>
  <li class="headerrow">
    <ul class="headercontainer">
      <li class="header id"></li>
      <li class="header product">Detalhes do item</li>
      <li class="header qt">
        <button
          @click="filterByBroad"
          :class="{ 'cp1-button__active': filters.isBroad }"
          class="cp1-small-button"
          title="Exibe somente os itens que são de AMPLA concorrência">
          AMPLA
        </button>
        <button
          @click="filterByQuoted"
          :class="{ 'cp1-button__active': filters.wasQuoted }"
          class="cp1-small-button"
          title="Exibe somente os itens cotados">
          COTADOS
        </button>
      </li>
      <li class="header result">
        <span class="title">Vencedor</span>
        <select
          class="cp1-small-select select"
          v-model="filters.winner">
          <option value="">TODOS AS EMPRESAS</option>
          <option
            v-for="(winner, winnerIdx) in winnerList"
            :key="winnerIdx"
            :value="winner">{{ winner }}</option>
        </select>
      </li>
      <li class="header result">
        <span class="title">2º Lugar</span>
        <select
          class="cp1-small-select select"
          v-model="filters.second">
          <option value="">TODOS AS EMPRESAS</option>
          <option
            v-for="(second, secondIdx) in secondList"
            :key="secondIdx"
            :value="second">{{ second }}</option>
        </select>
      </li>
      <li class="header result">
        <span class="title">3º Lugar</span>
        <select
          class="cp1-small-select select"
          v-model="filters.third">
          <option value="">TODOS AS EMPRESAS</option>
          <option
            v-for="(third, thirdIdx) in thirdList"
            :key="thirdIdx"
            :value="third">{{ third }}</option>
        </select>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'ListHeader',
  props: {
    winnerList: {
      default: []
    },
    secondList: {
      default: []
    },
    thirdList: {
      default: []
    }
  },
  data: () => ({
    filters: {
      winner: '',
      second: '',
      third: '',
      wasQuoted: false,
      isBroad: false
    }
  }),
  watch: {
    'filters.winner' (v) {
      this.$emit('select-winner', v)
    },
    'filters.second' (v) {
      this.$emit('select-second', v)
    },
    'filters.third' (v) {
      this.$emit('select-third', v)
    }
  },
  methods: {
    filterByQuoted () {
      this.filters.wasQuoted = !this.filters.wasQuoted
      this.$emit('select-quoted', this.filters.wasQuoted)
    },
    filterByBroad () {
      this.filters.isBroad = !this.filters.isBroad
      this.$emit('select-broad', this.filters.isBroad)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-result/components/list-header/ListHeader.vue